import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';

@Component({
  selector: 'subscribe',
  templateUrl: './subscribe.component.html',
  styleUrls: ['./subscribe.component.css']
})
export class SubscribeComponent implements OnInit {

  empty:boolean ; 
  invalid:boolean ; 
  success:boolean ; 
  loader:boolean  = false;
  inputValue:string ; 
  constructor() { }

  ngOnInit() {

  }

  resart()
  {
    this.loader = true ; 
    this.empty = false ; 
    this.invalid = false ; 
    this.success = false ;
    var global = this ;
     this.inputValue = $("#myEma").val();
     if(this.inputValue === "")
     {
        setTimeout(function(){
          global.loader = false ; 
          global.empty = true ;
          global.invalid = false ; 
          global.success = false ; 
        },1000)
     }
     else if(this.inputValue.indexOf('@') === -1)
     {
      setTimeout(function(){
        global.loader = false ; 
        global.invalid = true ;
        global.empty = false ; 
        global.success = false ; 
      },1000)
     }
     else
     {
      setTimeout(function(){
        global.loader = false ; 
        global.success = true ;
        global.empty = false ; 
        global.invalid = false ; 
        $("#myEma").val("");
      },1000)
     }
     
  }
}
